// Catat hasil uji (operator of a Bengkel Uji): a cylinder that arrived on a Penarikan is passed or failed.
// Formal and calm: no exclamation marks; "Reader", "Bengkel Uji" and "Surat Jalan" capitalised.

export const TEST = {
  title: 'Catat hasil uji',
  sub: (place: string) => `di ${place}`,
  /** the home tile */
  tileSub: 'Lulus atau gagal untuk tabung yang tiba di Bengkel Uji',
  onlyTitle: 'Hanya di Bengkel Uji',
  onlyBody: (place: string | undefined) => `Hasil uji dicatat oleh petugas Bengkel Uji. ${place ?? 'Titik Distribusi ini'} bukan Bengkel Uji.`,
  noPermission: 'Akun ini tidak memiliki izin mencatat hasil uji. Hubungi administrator.',
  /** picking the cylinder */
  pick: {
    searchLabel: 'Nomor seri tabung',
    placeholder: 'Nomor seri atau awal EPC',
    short: (min: number) => `Ketik minimal ${min} karakter untuk mencari.`,
    stock: 'Tabung di Bengkel Uji ini',
    stockHint: 'Tabung yang tiba lewat Surat Jalan dan belum dimusnahkan.',
    stockEmpty: 'Belum ada tabung tercatat di Bengkel Uji ini. Tabung tampil di sini setelah Surat Jalan penarikan diterima.',
    noResult: 'Tidak ada tabung dengan nomor itu di Bengkel Uji ini.',
    more: 'Masih ada tabung lain. Ketik nomor serinya untuk mencari.',
    clear: 'Hapus pencarian',
  },
  /** the chosen cylinder */
  subject: {
    back: 'Pilih tabung lain',
    notFound: 'Tabung ini tidak ditemukan atau berada di luar wilayah akun Anda.',
    nextTest: 'Uji berkala tercatat',
    lastResult: 'Hasil uji terakhir',
    none: 'Belum pernah diuji',
    notHere: 'Tabung ini tidak tercatat berada di Bengkel Uji ini, jadi hasil ujinya tidak dapat dicatat di sini.',
    destroyed: 'Tabung ini sudah dimusnahkan. Hasil uji tidak dapat dicatat lagi.',
    lost: 'Tabung ini tercatat hilang. Hasil ujinya tidak dapat dicatat sebelum diaktifkan kembali oleh admin.',
    onShipment: 'Tabung ini sedang dimuat ke Surat Jalan. Keluarkan dari muatan terlebih dahulu.',
  },
  /** the verdict */
  form: {
    result: 'Hasil uji',
    pass: 'Lulus',
    passSub: 'Layak edar, kembali ke stok Bengkel Uji',
    fail: 'Gagal',
    failSub: 'Tidak layak, tabung dimusnahkan',
    nextDue: 'Uji berkala berikutnya',
    nextDueHelp: (max: string) => `Setelah hari ini, paling lambat ${max}.`,
    reason: 'Alasan gagal',
    reasonPlaceholder: 'Contoh: retak pada dinding tabung',
    reasonHelp: (min: number, max: number) => `${min}–${max} karakter. Tersimpan di riwayat uji dan Log aktivitas.`,
    save: 'Simpan hasil uji',
    pickResult: 'Pilih Lulus atau Gagal',
    needNetwork: 'Tidak ada koneksi internet',
    errors: {
      result: 'Pilih Lulus atau Gagal.',
      due: 'Pilih tanggal, bulan, dan tahun uji berkala berikutnya.',
      dueRange: (max: string) => `Uji berkala berikutnya harus setelah hari ini dan paling lambat ${max}.`,
      reason: 'Tulis alasan tabung gagal uji.',
      reasonShort: (min: number) => `Alasan minimal ${min} karakter.`,
      reasonLong: (max: number) => `Alasan paling banyak ${max} karakter.`,
    },
  },
  /** the strong confirmation of a failed test */
  destroy: {
    title: (serial: string) => `Musnahkan ${serial}?`,
    body: 'Tabung akan dimusnahkan dan tagnya tidak bisa dipakai lagi. Hasil ini tidak dapat dibatalkan.',
    confirm: 'Ya, musnahkan',
    cancel: 'Periksa lagi',
  },
  /** after saving */
  done: {
    passToast: (serial: string) => `${serial} lulus uji`,
    failToast: (serial: string) => `${serial} dicatat gagal uji dan dimusnahkan`,
    passTitle: 'Hasil uji tersimpan: Lulus',
    failTitle: 'Hasil uji tersimpan: Gagal',
    passBody: (due: string) => `Uji berkala berikutnya ${due}. Tabung kembali aktif dan dapat dikirim lewat Surat Jalan distribusi.`,
    failBody: 'Tabung dimusnahkan. Tagnya tidak berlaku lagi dan tidak dapat dipakai tabung lain.',
    next: 'Catat tabung berikutnya',
    home: 'Kembali ke beranda',
  },
} as const;
